<template>
  <l-stack-v3
    :class="$style['ua-market-selection']">
    <h1 class="u-txt-ctr">
      {{ pageTitle }}
    </h1>
    <button
      type="button"
      class="c-button-v3  c-button-v3--tertiary  c-button-v3--wide"
      @click.prevent="selectMarket('k-12')">
      K-12 School
    </button>
    <button
      type="button"
      class="c-button-v3  c-button-v3--tertiary  c-button-v3--wide"
      @click.prevent="selectMarket('college-university')">
      College or University
    </button>
    <button
      type="button"
      class="c-button-v3  c-button-v3--tertiary  c-button-v3--wide"
      @click.prevent="selectMarket('international-other')">
      International or Other
    </button>
  </l-stack-v3>
</template>

<script setup>
  import useSchoolSearchStore from '../stores/use_school_search_store.js';

  const props = defineProps({
    pageTitle: {
      type: String,
    },
    cancelBtnLabel: {
      type: String,
    },
    cancelPath: {
      type: String,
    },
  });

  const store = useSchoolSearchStore();

  const selectMarket = (marketName) => {
    store.selectedMarket = marketName;
  };

</script>

<style lang="scss" module>
  @use 'music/app/styles/library/base' as * ;

  .ua-market-selection {
    margin: auto;
  }
</style>
